// THIS FILE IS GENERATED BY 'npm run set-env-variables'

export const environment = {
  production: true,

  // Configuration/Feature-switches:
  envName: '',
  useServiceWorker: true,
  useOffers: true,
  useQandAs: true,
  useQandASearch: true,
  useRegionPerLocale: false,
  useFeedbackPrompt: false,

  searchApi: 'https://hia-search.azurewebsites.net/search',
  searchApiKey: 'qiuuxg&LW$#MWLZZcrv9rhbf7JS*VEJza6RqD3wDpt',

  // Configuration of content
  localeLanguage: 'en',
  localeDir: 'ltr',
  localeAlternatives: 'en:English, es:Español, fr:Français, ar:العربية',
  localeAlternativesExplanation: '* Translations via Google Translate',
  appName: 'Global Dialogue Platform 2025',
  appLogoUrl: 'https://events.anticipation-hub.org/_files/c6df5d7b-07bb-48a5-8e87-55a207901fe6/gdp_10th_red.png',
  mainPageHeader: '',
  mainPageIntroduction: '\n \n',
  mainPageNotification: '',
  pageAbout: '\n',
  pagePrivacy: '\n',
  mainFooter: '**Built by the Netherlands Red Cross**  \n \n',
  errorHeader: 'Data Unavailable',
  errorMessage: 'Reach out to us at support@510.global',
  errorContactUrl: 'https://github.com/rodekruis/hia-gdp-25',
  errorRetry: 'Try again?',

  // Regions:
  regionConfig: '',
  regions: 'en',
  regionsLabels: 'Main Menu',
  regionsSheetIds: '1Cc7tAFJw56nPadyw7OmI7zYZs-IqzV29rESVtWv6ho0',

  // Third-party tokens:
  google_sheets_api_key: 'AIzaSyDuBKBIIRBABW57-lFCl2E-SwNE6mSB2K4',
  google_sheets_api_url: 'https://sheets.googleapis.com/v4/spreadsheets',
  matomoConnectionString: '',
  appInsightsConnectionString: '',
};
